export enum LeftMenuGlobalTabs {
  Frontend = 'frontend',
  Backend = 'backend',
  App = 'app',
}
